export const URL_API = 'https://oauth.reddit.com';
export const URL_AUTH = 'https://www.reddit.com/api/v1/authorize?';
export const CLIENT_ID = '0oll_xySJvUTQzQpd-Oqgw';
export const RESPONCE_TYPE = 'token';
export const RANDOM_STRING = 'random_string';
export const REDIRECT_URI = 'https://reactapp-blogget.vercel.app/auth';
export const SCOPE = 'identity submit read';
